import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { combineLatest } from "rxjs";
import { distinctUntilChanged, first, map } from "rxjs/operators";
import { ZonesService } from "src/app/services/zones.service";
@Component({
	selector: "app-wizard-step",
	templateUrl: "./wizard-step.component.html",
	styleUrls: ["./wizard-step.component.scss"],
})
export class WizardStepComponent implements OnInit {
	constructor(private zoneService: ZonesService) {}
	@Input() step: number;
	@Input() label: string;
	@Input() isCurrentStep: boolean;

	@Output() clicked = new EventEmitter();

	shouldDisable$ = combineLatest([
		this.zoneService.divisionId$.pipe(distinctUntilChanged()),
		this.zoneService.hasOneDivision$.pipe(distinctUntilChanged()),
	]).pipe(
		map(([divId, hasOneDiv]) => {
			if (hasOneDiv) {
				return true;
			}

			return Boolean(divId);
		}),
	);

	ngOnInit(): void {}

	onClick() {
		this.shouldDisable$.pipe(first()).subscribe(hasDivId => {
			if (hasDivId) {
				this.clicked.emit();
			}
		});
	}
}
